import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { postToHub } from "../../network/actions";
import { useNotificationContext } from "../../context/NotificationContext";

const CONFIRM = "Confirm";
const CANCEL = "Cancel";

const ActionButtons = ({ rowData, setReloadCount }) => {
  
  const { state } = rowData

  const {toast} = useNotificationContext();

  const [dialogType, setDialogType] = useState("");

  const showConfirmButton = state === "Overbooked"
  const showCancelButton = state === "Overbooked" || state === "Ok" || state === "OverbookConfirmation"   

  if(!showConfirmButton && !showCancelButton) { 
    return null;
  }

  const successCallBack = () => {
    setReloadCount(reloadCount => reloadCount + 1);
  };

  const errorCallback = () => {
    toast.current.show({severity: 'error', summary: 'Operation Failed'});
  }

  const onProceed = async () => {
    const url = `excursions/${dialogType === CONFIRM ? "confirm" : "cancel"}/${
      rowData.reference
    }`;
    await postToHub(url, {}, successCallBack, errorCallback);
    setDialogType("");
  };

  const footer = (
    <div>
      <Button label="Proceed" icon="pi pi-check" onClick={onProceed} />
      <Button
        label="Close"
        icon="pi pi-times"
        onClick={() => setDialogType("")}
        outlined
      />
    </div>
  );

  return (
    <div className="flex justify-evenly ">
      {showConfirmButton && (
        <Button
          className="mr-2"
          icon="pi pi-check"
          tooltip="Confirm"
          tooltipOptions={{ position: "top" }}
          onClick={() => setDialogType(CONFIRM)}
        />
      )}

      {showCancelButton && (
        <Button
          severity="danger"
          icon="pi pi-times"
          tooltip="Cancel"
          tooltipOptions={{ position: "top" }}
          onClick={() => setDialogType(CANCEL)}
        />
      )}
      <Dialog
        header="Confirmation"
        footer={footer}
        visible={!!dialogType}
        style={{ width: "50vw" }}
        onHide={() => setDialogType("")}
        modal
      >
        <div>
          <p className="mb-4">{`You are about to ${dialogType} this Booking. `}</p>
          <p>{`Account Number: ${rowData.accountNumber}`}</p>
          <p>{`Cabin Number: ${rowData.cabinNumber}`}</p>
          <p>{`Excursion code: ${rowData.bookingCode}`}</p>
          <p>{`Booking State: ${rowData.state}`}</p>
        </div>
      </Dialog>
    </div>
  );
};

export default ActionButtons;
